import { useRewardForm } from '@/common/reward/form';
import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useStarterPackReward } from '@/modules/starter/pack/reward/model/mixins';
import { StarterPackFeatureMapping, StarterPackRewardType } from '@/modules/starter/pack/reward/types';
import { ROUTE_NAME_STARTER } from '@/modules/starter/pack/router';
import { starterPackService } from '@/services/starter';
import useVuelidate from '@vuelidate/core';
import { required, requiredIf } from '@vuelidate/validators';
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

export function useStarterPackRewardAdd() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const starterPackId = StringUtils.toNumber(route.params.starterPackId);
    const starterPackType = ref<StarterPackRewardType>(StarterPackRewardType.AvatarBundle);

    const { model, feature } = useRewardForm({
        type: starterPackType,
        data: null as number | null,
        quantity: 1
    });

    const { fetchLinkableRewards, rewardOptions } = useStarterPackReward(starterPackType);

    const validations = {
        type: { required },
        data: { requiredIf: requiredIf(() => model.type !== StarterPackRewardType.NoAds) },
        quantity: { required }
    };

    const v$ = useVuelidate(validations, model);

    const create = crudAction.excuteAndNotify({
        validator: v$,
        request: () => starterPackService.reward.add(starterPackId, model.type, model.data, model.quantity),
        onSuccess: () => router.push({ name: ROUTE_NAME_STARTER.PACK.REWARD.INDEX, params: { starterPackId } })
    });

    const quickCreate = crudAction.excuteAndNotify({
        validator: v$,
        request: (forStarterPackId: number) =>
            starterPackService.reward.add(forStarterPackId, model.type, model.data, model.quantity)
    });

    const changeType = (type: number) => {
        feature.value = StarterPackFeatureMapping.get(type);
    };

    watch(() => model.type, changeType);

    return { model, v$, fetchLinkableRewards, rewardOptions, create, quickCreate };
}
